import {
  IconSearch,
  IconStethoscope,
  IconUsers,
  IconWindmill,
  IconUser,
  IconReportMoney,
  IconNurse,
  IconPill,
  IconMassage,
  IconReportMedical,
  IconUserPlus,
  IconBuildingHospital,
  IconUserCircle,
  IconReportAnalytics
} from "@tabler/icons";

const icons = {
  IconSearch,
  IconStethoscope,
  IconUsers,
  IconWindmill,
  IconUser,
  IconReportMoney,
  IconNurse,
  IconPill,
  IconMassage,
  IconReportMedical,
  IconUserPlus,
  IconBuildingHospital,
  IconUserCircle,
  IconReportAnalytics
};

const clinicManagement = {
  id: "clinicManagement",
  type: "group",
  title: "Clinic Management",
  children: [
    {
      id: "employees",
      title: "Add Employee",
      type: "item",
      icon: icons.IconUserPlus,
      breadcrumbs: "true",
      url: "/employee/add",
    },
    {
      id: "clinic-management",
      title: "Employees",
      type: "collapse",
      icon: icons.IconUsers,
      breadcrumbs: "true",
      children: [
        {
          id: "admins",
          title: "Admins",
          type: "item",
          icon: icons.IconUserCircle,
          breadcrumbs: "true",
          url: "/admins",
        },
        {
          id: "doctors",
          title: "Doctors",
          type: "item",
          icon: icons.IconStethoscope,
          breadcrumbs: "true",
          url: "/doctors",
        },
        {
          id: "secretary",
          title: "Secretaries",
          type: "item",
          icon: icons.IconBuildingHospital,
          breadcrumbs: "true",
          url: "/secretaries",
        },
        {
          id: "nurses",
          title: "Nurses",
          type: "item",
          icon: icons.IconNurse,
          breadcrumbs: "true",
          url: "/nurses",
        },
        {
          id: "assistants",
          title: "Assistants",
          type: "item",
          icon: icons.IconReportAnalytics,
          breadcrumbs: "true",
          url: "/assistants",
        },
        // {
        //   id: "pharmacist",
        //   title: "Pharmacists",
        //   type: "item",
        //   icon: icons.IconPill,
        //   breadcrumbs: "true",
        //   url: "/pharmacists",
        // },
        // {
        //   id: "accountant",
        //   title: "Accountants",
        //   type: "item",
        //   icon: icons.IconReportMoney,
        //   breadcrumbs: "true",
        //   url: "/accountants",
        // },
      ],
    },
  ],
};

export default clinicManagement;
